import { InventoryDetailContent } from "../../content/inventory/inventoryDetail";
import { Layout } from "../../layout/page";

export function InventoryDetail() {
  return (
    <Layout>
      <InventoryDetailContent />
    </Layout>
  );
}
